import React from "react";
import CustomImageCard from "../componenets/custom";

const TestPage = () => {
  return (
    <div className="w-full max-w-[1300px] px-5 md:px-8 2xl:p-0 mx-auto">
      <div className="pt-[50px] md:pt-[80px]">
        <CustomImageCard />
      </div>
    </div>
  );
};

export default TestPage;
